import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { ErrorTooltip } from '@retail/components';
import { StyledTextField } from '@retail/my-assortment/components';
import { Box, Tooltip } from '@mui/material';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  error?: string;
  fieldName: TName;
  control: Control<TFieldValues>;
  disabled?: boolean;
}

export const PercentageInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  error,
  fieldName,
  disabled,
}: Props<TFieldValues, TName>) => {
  const t = useCampaignTFunction();
  return (
    <Box display="flex" alignItems="center">
      <Controller
        name={fieldName}
        disabled={disabled}
        control={control}
        render={({ field }) =>
          disabled ? (
            <Tooltip title={t('campaign.messages.needSalesPrice')}>
              <StyledTextField {...field} value="" size="small" width={115} error={!!error} />
            </Tooltip>
          ) : (
            <ErrorTooltip title={error} arrow>
              <StyledTextField
                {...field}
                value={field.value ?? ''}
                size="small"
                width={115}
                error={!!error}
              />
            </ErrorTooltip>
          )
        }
      />
    </Box>
  );
};
